<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="copyright-page">
<div epub:type="bodymatter">
<section epub:type="division">
<p class="image"><a id="pageiv"></a><img alt="" src="OEBPS/images/L01.jpg"/></p>
<p class="crt">STERLING and the distinctive Sterling logo are registered trademarks of Sterling Publishing Co., Inc.</p>
<p class="crt">Compilation © 2017 Linda Picone</p>
<p class="crt">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means (including electronic, mechanical, photocopying, recording, or otherwise) without prior written permission from the publisher.</p>
<p class="crt">ISBN 978-1-4549-2783-9</p>
<p class="crt">For information about custom editions, special sales, and premium and corporate purchases, please contact Sterling Special Sales at 800-805-5489 or <a class="hlink" href="mailto:specialsales@sterlingpublishing.com">specialsales@sterlingpublishing.com</a>.</p>
<p class="crt"><a class="hlink" href="http://sterlingpublishing.com" target="_blank">sterlingpublishing.com</a></p>
<p class="crt">Book design by Christine Heun</p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454927839_epub_cop_r1.vue?c6f43946